import { render, staticRenderFns } from "./editReciepeForm.vue?vue&type=template&id=8bba1f08&"
import script from "./editReciepeForm.vue?vue&type=script&lang=js&"
export * from "./editReciepeForm.vue?vue&type=script&lang=js&"
import style0 from "./editReciepeForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports